import { Fancybox } from '@fancyapps/ui';

// The wizard steps are server-rendered in templates/program-finder.php, each
// containing a real FaceWP facet (facetwp_display). Clicking an option IS
// clicking the facet — FaceWP syncs the sidebar, results, and URL natively.
// This module only handles which step is visible.

let path      = null; // data-path key ('educator' | 'parent' | ...)
let stepIndex = -1;   // -1 = role-select step

function getWizard() {
	const $ = window.jQuery;
	// Fancybox moves the element into its container — check there first
	const $moved = $('.fancybox__container #program-wizard');
	return $moved.length ? $moved : $('#program-wizard');
}

// Steps for the current path that actually offer a choice, plus the shared
// steps (data-path="all") appended to the end of every path. A facet with
// fewer than two options (e.g. placeholder ACF choices) can't narrow
// results, so its step is skipped. Slider (price) and proximity (zip)
// facets always count — they render no discrete options.
function pathSteps($w) {
	return $w
		.find(`.wizard__step[data-path="${path}"], .wizard__step[data-path="all"]`)
		.filter((_, el) =>
			el.querySelector('.facetwp-type-slider, .facetwp-type-proximity') !== null ||
			el.querySelectorAll('.facetwp-checkbox, .facetwp-radio, option').length >= 2
		);
}

function render() {
	const $w = getWizard();
	if (!$w.length) return;

	const $steps = path ? pathSteps($w) : window.jQuery();
	const pct    = $steps.length && stepIndex >= 0
		? Math.round(((stepIndex + 1) / $steps.length) * 100)
		: 0;

	$w.find('.wizard__step').attr('hidden', true);

	if (stepIndex === -1) {
		$w.find('[data-wizard-roles]').removeAttr('hidden');
		$w.find('.wizard__nav-btns').empty();
	} else {
		$steps.eq(stepIndex).removeAttr('hidden');
		const isLast = stepIndex === $steps.length - 1;
		$w.find('.wizard__nav-btns').html(
			'<button type="button" class="wizard__back">Go back</button>' +
			`<button type="button" class="wizard__next">${isLast ? 'View Results' : 'Next Question'}</button>`
		);
	}

	$w.find('.wizard__progress-bar').css('width', pct + '%');
	$w.find('.wizard__progress-track').attr('aria-valuenow', pct);
}

export default {
	init() {
		const $ = window.jQuery;

		function openWizard() {
			path      = null;
			stepIndex = -1;
			render();

			Fancybox.show([{ src: '#program-wizard', type: 'inline' }], {
				mainClass:     'wizard-fancybox',
				backdropClick: false,
				animated:      true,
				Hash:          false, // its own hash handling would close us on #wizard
				// No swipe/drag — it fights with the facet inputs (zip, slider)
				dragToClose:   false,
				Carousel:      { gestures: false },
				on: {
					destroy: () => {
						// Strip #wizard so the same link can re-open the modal
						if (window.location.hash === '#wizard') {
							history.replaceState(null, '', window.location.pathname + window.location.search);
						}
					},
				},
			});
		}

		$(document).on('click', '.program-wizard__trigger', openWizard);

		// Deep link: /program-finder/#wizard auto-opens the wizard
		function openFromHash() {
			if (window.location.hash === '#wizard' && document.getElementById('program-wizard')) {
				openWizard();
			}
		}

		window.addEventListener('hashchange', openFromHash);
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', openFromHash);
		} else {
			openFromHash();
		}

		// Role selection — advances to the first step of that path
		$(document).on('click', '#program-wizard .wizard__option[data-role]', function () {
			path      = $(this).data('role');
			stepIndex = 0;
			render();
		});

		// Next / View Results — selections are already live via FaceWP,
		// so the last step just closes the modal
		$(document).on('click', '#program-wizard .wizard__next', function () {
			if (stepIndex === pathSteps(getWizard()).length - 1) {
				Fancybox.close();
			} else {
				stepIndex++;
				render();
			}
		});

		// Go back
		$(document).on('click', '#program-wizard .wizard__back', function () {
			if (stepIndex > 0) {
				stepIndex--;
			} else {
				stepIndex = -1;
				path      = null;
			}
			render();
		});

		// Skip — advance without selecting; close on role step
		$(document).on('click', '#program-wizard .wizard__skip', function () {
			if (stepIndex === -1) {
				Fancybox.close();
				return;
			}
			if (stepIndex === pathSteps(getWizard()).length - 1) {
				Fancybox.close();
			} else {
				stepIndex++;
				render();
			}
		});
	},
};
